export const deleteGroupsBulkActionType = 'deleteGroups';
